import GTDRRadarChart from "@/pages/dashboard/pages/benchmark/gtdrAssessment/components/GTDRRadarChart";
import React, { useContext, useMemo } from "react";
import BackgroundWhite from '@/pages/home/assets/img/studio/studio-assessment-radar-light.png';
import BackgroundWhiteCn from '@/pages/home/assets/img/studio/studio-assessment-radar-light-cn.png';
import BackgroundDark from '@/pages/home/assets/img/studio/studio-assessment-radar-dark.png';
import BackgroundDarkCn from '@/pages/home/assets/img/studio/studio-assessment-radar-dark-cn.png';
import { useIntl } from "umi";
import { LANGUAGE_EN } from "@home/_config/config";
import './index.scss';
import { getName } from "@home/utils/common";
import { StudioContext } from "../../../context";
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';
import { changeStudioName } from "@/pages/home/pages/studio/studioAssessment/components/StudioAssessnebtTableCard";

const StudioAssessmentRadarChart = (props: any) => {
  const {checkColorMap, checkColorMapDark, dimensionColorMap, data, backgroundWhite, backgroundWhiteCn, backgroundDark, backgroundDarkCn } = props;
  const { companyInfo, currentGame } = useContext(StudioContext);
  const { riskLevel } = data || {};
  const { data: riskData } = riskLevel || {};
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const columns: any[] = [
    {
      key: 'name',
      header: getName(isEn, 'Dimension', '维度大类'),
      style: { width: '300px', fontWeight: 600 },
      render: (value: { name: string; color: string; }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            className= 'dbd-benchmark-gtdr-risk-level-table-category-cube'
            style={{ backgroundColor: value?.color, }}
          />
          <div>{value?.name}</div>
        </div>
      ),
    },
    {
      key: 'status',
      header: getName(isEn, 'Status', '状态'),
      style: { minWidth: '380px', fontWeight: 600 },
      render: (value: string) => (
        <FormatHtmlTextToReact text={value} />
      ),
    },
    {
      key: 'recommendation',
      header: getName(isEn, 'Recommendation', '建议'),
      style: { minWidth: '380px', fontWeight: 600 },
      render: (value: string) => (
        <FormatHtmlTextToReact text={value} />
      ),
    },
  ];
  const formattedData = useMemo(() => {
    const newData = riskData?.map((item: any) => {
      const {
        category_cn,
        category_en,
        status_cn,
        status_en,
        recommendation_cn,
        recommendation_en,
        category
      } = item;
      return {
        name: {name: getName(isEn, category_en, category_cn),color: dimensionColorMap[category]},
        status: getName(isEn, status_en, status_cn),
        recommendation: getName(isEn, recommendation_en, recommendation_cn),
      };
    });
    return newData || [];
  }, [riskData, dimensionColorMap, isEn]);

  return(
    <GTDRRadarChart
      {...props}
      className={'dbh-studio-assesment-radar-chart'}
      backgroundWhite={ backgroundWhite || BackgroundWhite}
      backgroundWhiteCn={ backgroundWhiteCn || BackgroundWhiteCn}
      backgroundDark={ backgroundDark || BackgroundDark}
      backgroundDarkCn={ backgroundDarkCn || BackgroundDarkCn}
      radarStartAngle={170}
      filterValue={{version: props?.filterValue?.competitors?.map(item => item?.version) || []}}
      gameName={props?.filterValue?.competitors?.map(item => changeStudioName(item?.studio, currentGame, companyInfo)) || []}
      gameCover={props?.filterValue?.competitors?.map(item => item?.cover) || []}
      checkColorMap={checkColorMap}
      checkColorMapDark={checkColorMapDark}
      radarRadius={["0%", "45%"]}
      radarLabelNameGap = {100}
      checkBorderWidth = {1}
      isStudioChart = {true}
      riskColumns={columns}
      isSort={false} // 不能排序 否则version和gameName会有顺序问题
      formattedRiskData={formattedData}
      cardHeight={"unset"}
      colorArrLess={["#5E54CC", "#F8D74D" , "#A6C9FF"]}
      colorArrMore={["#5E54CC", "#F8D74D", "#A6C9FF", "#69D19C", "#F17C86", "#5e54cc5c", "#7f6ff15c", "#ad9eff5c", "#d2c8fd5c", "#efebff5c", "#1B1C59", "#292880", "#413CA6", "#7F6FF1", "#D2C8FD", "#EFEBFF"]}
    />
  );
};

export default StudioAssessmentRadarChart;
